import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button } from 'reactstrap'
import axios from 'axios'
import pubsub from 'pubsub-js'
import { APPLICANTS_API } from '../../../utils/consts'

const ScheduleInterviewModal = ({ show, onHide, applicantId, onSuccess }) => {
  const [interviewDate, setInterviewDate] = useState('')
  const [notes, setNotes] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (show) {
      setInterviewDate('')
      setNotes('')
      setError('')
    }
  }, [show])

  const handleSubmit = async () => {
    if (!interviewDate) {
      setError('Interview date is required')
      return
    }

    const date = new Date(interviewDate)

    setSubmitting(true)
    setError('')

    try {
      const { data } = await axios.post(
        `${APPLICANTS_API}/applicants/schedule-interview`,
        {
          applicantId,
          interview_date: date.toISOString(),
          notes: notes || undefined
        },
        { withCredentials: false }
      )

      if (data.success) {
        pubsub.publish('showNotification', {
          message: 'Interview scheduled successfully',
          type: 'success'
        })
        onSuccess?.()
        onHide()
      } else {
        throw new Error(data.message || 'Failed to schedule interview')
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Failed to schedule interview'
      setError(message)
      pubsub.publish('showNotification', {
        message,
        type: 'error'
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal show={show} onHide={onHide} className='modal-1'>
      <Modal.Header closeButton>
        <Modal.Title>Schedule Interview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mb-3'>
          <label className='form-label'>Interview Date</label>
          <input
            type='datetime-local'
            className='form-control'
            value={interviewDate}
            onChange={(e) => setInterviewDate(e.target.value)}
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>Optional notes</label>
          <textarea
            className='form-control'
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder='Add any notes...'
          />
        </div>
        {error && (
          <div className='text-danger mb-2' style={{ fontSize: '14px' }}>
            {error}
          </div>
        )}
        <div className='d-flex gap-2'>
          <Button color='secondary' onClick={onHide} disabled={submitting}>
            Cancel
          </Button>
          <Button color='info' onClick={handleSubmit} disabled={!interviewDate || submitting}>
            {submitting ? 'Scheduling...' : 'Schedule Interview'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ScheduleInterviewModal
